export enum enPersonType {
  FOREIGNER = 'E',
  LEGAL_PERSON = 'J',
  NATURAL_PERSON = 'F'
}
